<template>
  <figure style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
    <chart :options="pieOptions" @click="setCountry" style='width: 100%; height: 100%' ref="pie" auto-resize v-if="dataState === 'ready'"></chart>
    <template v-else-if="dataState === 'loading'">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </template>
    <template v-else-if="dataState === 'noData'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
    </template>
    <template v-else-if="dataState === 'error'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
    </template>
  </figure>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      pieOptions: {
        tooltip: {trigger: 'item', formatter: '{a} <br/>{b} : {c} ({d}%)'},
        series: [{
          name: 'Tweets Types',
          type: 'pie',
          data: [
            {value: 0, name: 'None'}
          ]
        }]
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters']),
    setCountry: function (value) {
      if (value.data.id) {
        if (this.filters.countryId.length > 0) {
          this.setCustomFilters({countryId: []})
          this.$store.commit('setSelectedCountries', [])
        } else if (this.pieOptions.series[0].data.length === 1) {
          this.setCustomFilters({countryId: value.data.id})
          this.getCityData()
        } else {
          this.setCustomFilters({countryId: value.data.id})
        }
      }
    },
    getCityData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTweetsByCities', this.getQuery({sortBy: '_tweet_count', countryId: this.filters.countryId, pageSize: 100, order: 'DESC'}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          let data = []
          let totalNumber = 0
          if (r1.data.payload.length === 0) {
            data = [{value: 0, name: 'None'}]
            this.dataState = 'noData'
          } else {
            for (var i = 0; i < r1.data.payload.length; i++) {
              data.push({name: r1.data.payload[i]._city_name, value: r1.data.payload[i]._tweet_count, id: r1.data.payload[i]._city_id})
              totalNumber += r1.data.payload[i]._tweet_count
            }
            let otherData = 0
            let others = ['Others']
            let dataNoSmallValues = []
            for (var d = 0; d < data.length; d++) {
              if ((data[d].value * 100 / totalNumber) >= 1) {
                dataNoSmallValues.push(data[d])
              } else {
                others.push(data[d].name + ' : ' + data[d].value + ' (' + Number(data[d].value * 100 / totalNumber).toFixed(2) + '%)')
                otherData += data[d].value
              }
            }
            if (otherData > 0) {
              dataNoSmallValues.push({
                name: 'Other',
                value: otherData,
                tooltip: {
                  formatter: others.length > 15 ? others.slice(0, 15).join('<br>') + ' ...' : others.join('<br>')
                }
              })
            }
            this.pieOptions.series = []
            this.pieOptions.series.push({
              name: 'Tweets Cities',
              type: 'pie',
              data: dataNoSmallValues
            })
            this.dataState = 'ready'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    getCountryData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTweetsByCountries', this.getQuery({sortBy: '_tweet_count', order: 'DESC', pageSize: 100}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          let data = []
          let totalNumber = 0
          if (r1.data.payload.length === 0) {
            data = [{value: 0, name: 'None'}]
            this.dataState = 'noData'
          } else {
            for (var i = 0; i < r1.data.payload.length; i++) {
              data.push({name: r1.data.payload[i]._country_name, value: r1.data.payload[i]._tweet_count, id: r1.data.payload[i]._country_id})
              totalNumber += r1.data.payload[i]._tweet_count
            }
            let otherData = 0
            let others = ['Others']
            let dataNoSmallValues = []
            for (var d = 0; d < data.length; d++) {
              if ((data[d].value * 100 / totalNumber) >= 1) {
                dataNoSmallValues.push(data[d])
              } else {
                others.push(data[d].name + ' : ' + data[d].value + ' (' + Number(data[d].value * 100 / totalNumber).toFixed(2) + '%)')
                otherData += data[d].value
              }
            }
            if (otherData > 0) {
              dataNoSmallValues.push({
                name: 'Other',
                value: otherData,
                tooltip: {
                  formatter: others.length > 15 ? others.slice(0, 15).join('<br>') + ' ...' : others.join('<br>')
                }
              })
            }
            this.pieOptions.series = []
            this.pieOptions.series.push({
              name: 'Tweets Countries',
              type: 'pie',
              data: dataNoSmallValues
            })
            this.dataState = 'ready'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          if (this.filters.countryId.length > 0 && this.filters.cityId.length === 0) {
            this.getCityData()
          } else {
            this.getCountryData()
          }
        }
      }
    },
    loading: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          let pie = this.$refs.pie
          if (pie) {
            pie.showLoading({
              text: '',
              color: '#4ea397',
              maskColor: 'rgba(255, 255, 255, 0.4)'
            })
          }
        } else {
          let pie = this.$refs.pie
          if (pie) {
            pie.hideLoading()
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/TweetsLocationsPieChart.vue